<script>
export default {
    created: async function() {
        try {
            const user = JSON.parse(sessionStorage.getItem('user'))
            await this.$api.post('/logout', {
                userId: user.id
            })
            sessionStorage.clear()
            this.$cookies.remove('authToken')
            this.$router.push('/landing')
        } catch (error) {
            console.error(error)
        }
    }
}
</script>